import React from "react";
import { Box } from "@mui/material";
import LineaPedido from "./LineaPedido";

// Recuadro con las líneas del pedido. Recibe el objeto que devuelve useLineas
// (compartido por Nuevo Pedido y Editar Pedido).
export default function ListaLineasPedido({ lineas }) {
  const { datosRenglon } = lineas;

  return (
    <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "12px",
        margin: "8px 0",
        boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        backgroundColor: "#ffffff",
        width: "100%",
      }}
    >
      {datosRenglon
        ? datosRenglon.map((linea, index) => {
            const esEnvase = lineas.esLineaEnvase(linea);
            return (
              <LineaPedido
                key={index}
                linea={linea}
                index={index}
                esUltima={index === datosRenglon.length - 1}
                // Cualquier línea se puede borrar mientras quede al menos una.
                puedeEliminar={datosRenglon.length > 1}
                esEnvase={esEnvase}
                productos={esEnvase ? lineas.envases : lineas.productos}
                productoSeleccionado={lineas.getProductoById(linea.producto)}
                hayOtraPromo={lineas.tieneOtraPromo(index)}
                onPromoSenaChange={lineas.handlePromoSenaChange}
                onProductoChange={lineas.handleProductoChange}
                onCantidadChange={lineas.handleCantidadChange}
                onEspecificacionesChange={lineas.handleEspecificacionesChange}
                onEliminar={lineas.eliminarLinea}
                onAgregar={lineas.agregarLinea}
                onAgregarEnvase={lineas.agregarEnvase}
              />
            );
          })
        : null}
    </Box>
  );
}
